<template>
  <div>
    <el-divider content-position="left">{{ $t('영업 시간 설정') }}</el-divider>

    <el-row :gutter="10" style="line-height: 200%; margin-bottom: 10px">
      <el-col :md="5" class="form__field-align">
        <el-radio-group v-model="inputForm.detailYn" size="mini">
          <el-radio-button :label="false">{{ $t('간편설정') }}</el-radio-button>
          <el-radio-button :label="true">{{ $t('상세설정') }}</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col class="grid-title hidden-sm-and-down" :xs="9" :sm="9" :md="7">{{ $t('영업 시간') }}</el-col>
      <el-col class="grid-title hidden-sm-and-down" :xs="9" :sm="9" :md="8">{{ $t('BreakTime') }}</el-col>
      <el-col
        class="grid-title hidden-sm-and-down"
        :xs="6"
        :sm="6"
        :md="2"
        style="text-align: center"
        v-if="inputForm.detailYn"
        >{{ $t('일괄적용') }}</el-col
      >
    </el-row>

    <div v-if="inputForm.detailYn">
      <el-row :gutter="10" v-for="(item, index) in detailWeeks" class="form__field" :key="index">
        <el-col :md="5" class="form__field-align">{{ item.label }}</el-col>
        <el-col :md="7">
          <div class="form__field-label">{{ $t('영업 시간') }}</div>
          <el-form-item label-width="0" :error="formError['storeTimesDetail[' + index + '].tm']" size="mini">
            <el-time-select
              :placeholder="$t('시작')"
              v-model="inputForm.storeTimesDetail[index].startTm"
              style="width: 100px"
              :disabled="inputForm.storeTimesDetail[index].dayYn"
              :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"
              @change="batchChange(index, 'startTm')"></el-time-select>
            <el-time-select
              :placeholder="$t('종료')"
              v-model="inputForm.storeTimesDetail[index].endTm"
              style="width: 100px"
              :disabled="inputForm.storeTimesDetail[index].dayYn"
              :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"
              @change="batchChange(index, 'endTm')"></el-time-select>
            <el-tag
              v-if="isOvernight(inputForm.storeTimesDetail[index].startTm, inputForm.storeTimesDetail[index].endTm)"
              size="mini"
              type="warning"
              effect="plain"
              >{{ $t('다음날') }}</el-tag
            >
            <el-checkbox
              v-model="inputForm.storeTimesDetail[index].dayYn"
              :label="$t('24시간')"
              border
              @change="dayYnChange(index)"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <div class="form__field-label">{{ $t('BreakTime') }}</div>
          <el-form-item label-width="0" :error="formError['storeTimesDetail[' + index + '].btm']" size="mini">
            <div>
              <el-time-select
                :placeholder="$t('시작')"
                v-model="inputForm.storeTimesDetail[index].breakStartTm1"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakStartTm1')"></el-time-select>
              <el-time-select
                :placeholder="$t('종료')"
                v-model="inputForm.storeTimesDetail[index].breakEndTm1"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakEndTm1')"></el-time-select>
              <el-tag
                v-if="
                  isOvernight(
                    inputForm.storeTimesDetail[index].breakStartTm1,
                    inputForm.storeTimesDetail[index].breakEndTm1
                  )
                "
                size="mini"
                type="warning"
                effect="plain"
                >{{ $t('다음날') }}</el-tag
              >
            </div>
            <div>
              <el-time-select
                :placeholder="$t('시작')"
                v-model="inputForm.storeTimesDetail[index].breakStartTm2"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakStartTm2')"></el-time-select>
              <el-time-select
                :placeholder="$t('종료')"
                v-model="inputForm.storeTimesDetail[index].breakEndTm2"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakEndTm2')"></el-time-select>
              <el-tag
                v-if="
                  isOvernight(
                    inputForm.storeTimesDetail[index].breakStartTm2,
                    inputForm.storeTimesDetail[index].breakEndTm2
                  )
                "
                size="mini"
                type="warning"
                effect="plain"
                >{{ $t('다음날') }}</el-tag
              >
            </div>
          </el-form-item>
        </el-col>
        <el-col :md="2" class="form__field-align">
          <div class="form__field-label">{{ $t('일괄적용') }}</div>
          <el-checkbox
            v-model="inputForm.storeTimesDetail[index].isBatch"
            size="small"
            @change="batchChange(index)"></el-checkbox>
        </el-col>
      </el-row>
    </div>

    <div v-else>
      <el-row :gutter="10" v-for="(item, index) in simpleWeeks" class="form__field" :key="index">
        <el-col :md="5" class="form__field-align">{{ item.label }}</el-col>
        <el-col :md="7">
          <div class="form__field-label">{{ $t('영업 시간') }}</div>
          <el-form-item label-width="0" :error="formError['storeTimesSimple[' + index + '].tm']" size="mini">
            <el-time-select
              :placeholder="$t('시작')"
              v-model="inputForm.storeTimesSimple[index].startTm"
              style="width: 100px"
              :disabled="inputForm.storeTimesSimple[index].dayYn"
              :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"
              @change="batchChange(index, 'startTm')"></el-time-select>
            <el-time-select
              :placeholder="$t('종료')"
              v-model="inputForm.storeTimesSimple[index].endTm"
              style="width: 100px"
              :disabled="inputForm.storeTimesSimple[index].dayYn"
              :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"
              @change="batchChange(index, 'endTm')"></el-time-select>
            <el-tag
              v-if="isOvernight(inputForm.storeTimesSimple[index].startTm, inputForm.storeTimesSimple[index].endTm)"
              size="mini"
              type="warning"
              effect="plain"
              >{{ $t('다음날') }}</el-tag
            >
            <el-checkbox
              v-model="inputForm.storeTimesSimple[index].dayYn"
              :label="$t('24시간')"
              border
              @change="dayYnChange(index)"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <div class="form__field-label">{{ $t('BreakTime') }}</div>
          <el-form-item label-width="0" :error="formError['storeTimesSimple[' + index + '].btm']" size="mini">
            <div>
              <el-time-select
                :placeholder="$t('시작')"
                v-model="inputForm.storeTimesSimple[index].breakStartTm1"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakStartTm1')"></el-time-select>
              <el-time-select
                :placeholder="$t('종료')"
                v-model="inputForm.storeTimesSimple[index].breakEndTm1"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakEndTm1')"></el-time-select>
              <el-tag
                v-if="
                  isOvernight(
                    inputForm.storeTimesSimple[index].breakStartTm1,
                    inputForm.storeTimesSimple[index].breakEndTm1
                  )
                "
                size="mini"
                type="warning"
                effect="plain"
                >{{ $t('다음날') }}</el-tag
              >
            </div>
            <div>
              <el-time-select
                :placeholder="$t('시작')"
                v-model="inputForm.storeTimesSimple[index].breakStartTm2"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakStartTm2')"></el-time-select>
              <el-time-select
                :placeholder="$t('종료')"
                v-model="inputForm.storeTimesSimple[index].breakEndTm2"
                style="width: 95px"
                :picker-options="{
                  start: '00:00',
                  step: '00:05',
                  end: '23:59',
                }"
                @change="batchChange(index, 'breakEndTm2')"></el-time-select>
              <el-tag
                v-if="
                  isOvernight(
                    inputForm.storeTimesSimple[index].breakStartTm2,
                    inputForm.storeTimesSimple[index].breakEndTm2
                  )
                "
                size="mini"
                type="warning"
                effect="plain"
                >{{ $t('다음날') }}</el-tag
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <el-divider content-position="left">{{ $t('정기 휴무 설정') }}</el-divider>

    <el-row :gutter="10" style="line-height: 200%; margin-bottom: 10px">
      <el-col :md="5" class="form__field-align">
        <el-radio-group v-model="inputForm.tp" size="mini">
          <el-radio-button label="week">{{ $t('요일별 설정') }}</el-radio-button>
          <el-radio-button label="day">{{ $t('일자별 설정') }}</el-radio-button>
        </el-radio-group>
      </el-col>
      <template v-if="'week' == inputForm.tp">
        <el-col :md="3" class="form__field-align">
          <el-radio-group v-model="inputForm.weekTp" size="mini">
            <el-radio-button label="ew">{{ $t('매주') }}</el-radio-button>
            <el-radio-button label="bw">{{ $t('격주') }}</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :md="8">
          <el-form-item label-width="0">
            <mcombo :data="detailWeeks" :model="inputForm.weeks" @change="inputForm.weeks = $event"></mcombo>
          </el-form-item>
        </el-col>
        <el-col :md="8" v-if="'bw' == inputForm.weekTp">
          <el-form-item label-width="0">
            <el-switch
              v-model="inputForm.sniffling"
              :inactive-text="$t('이번주부터 휴무')"
              active-color="#ff4949"
              :active-text="$t('다음주부터 휴무')"
              inactive-color="#13ce66"></el-switch>
          </el-form-item>
        </el-col>
      </template>

      <template v-else>
        <el-col :md="10">
          <el-form-item label-width="0">
            <el-select v-model="inputForm.holidayDays" multiple :placeholder="$t('일자 선택')" style="width: 100%">
              <el-option v-for="item in 28" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </el-row>

    <el-divider content-position="left">{{ $t('기타 휴무 설정') }}</el-divider>

    <el-row>
      <el-col :md="20">
        <el-form-item :label="$t('휴일')" label-width="160px">
          <el-date-picker
            v-model="inputForm.vactionDays"
            type="dates"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="$t('일자 선택')"
            style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>

    <!--
      주문 단말 꺼짐 시 준비중(WP3 매장 칸 `preparingStatusYn`) — 영업시간·휴무와 같은 **영업 상태 축**이라 이 패널이 갖는다.
      기본 OFF 의 매장별 opt-in 이고 **매장 폼 저장**에 실린다(마지막 저장이 이긴다, 역할·대행 잠금 없음). 폼 위 임시중단
      카드(전용 경로·즉시 반영)와는 다른 축이라 그 카드에 넣지 않고, 제목도 그 카드(「주문 접수 임시중단」)와 겹치지 않게 적는다.
      이 도움말이 오탐(키오스크 전용 단말·어드민 주문 화면만 쓰는 매장)을 덮는 유일한 수단이다 — 줄이지 않는다.
    -->
    <el-divider content-position="left">{{ $t('주문 단말 꺼짐 시 준비중') }}</el-divider>

    <el-row>
      <el-col :md="20">
        <el-form-item
          :label="$t('주문 단말 꺼짐 시 준비중 표시')"
          label-width="220px"
          :error="formError.preparingStatusYn">
          <el-switch v-model="inputForm.preparingStatusYn" class="preparing-status-switch"></el-switch>
          <div class="form-field-hint">
            {{
              $t(
                'ON 이면 영업시간이어도 주문 단말(POS)이 꺼져 있을 때 고객 화면에 「준비중」을 표시하고 주문을 받지 않습니다. 판정은 POS 가 주문 목록을 읽고 있는지로 하며(키오스크 전용 단말 포함) 꺼짐 감지까지 최대 3분이 걸립니다. 어드민 주문 화면만 쓰는 매장은 켜지 마세요 — 항상 준비중이 됩니다. OFF 면 기존대로 영업중/영업종료만 표시합니다.'
              )
            }}
          </div>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { util } from '@/mixins/utilMixin'

export default {
  props: ['value', 'formError'],
  data() {
    const data = {}

    data.simpleWeeks = [{ label: this.$t('평일') }, { label: this.$t('주말') }]

    data.detailWeeks = [
      { label: this.$t('월요일'), value: 1 },
      { label: this.$t('화요일'), value: 2 },
      { label: this.$t('수요일'), value: 3 },
      { label: this.$t('목요일'), value: 4 },
      { label: this.$t('금요일'), value: 5 },
      { label: this.$t('토요일'), value: 6 },
      { label: this.$t('일요일'), value: 7 },
    ]

    return data
  },
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },

  methods: {
    isOvernight: function (startTm, endTm) {
      return !util.isEmpty(startTm) && !util.isEmpty(endTm) && endTm < startTm
    },
    dayYnChange: function (index) {
      if (this.inputForm.detailYn) {
        if (this.inputForm.storeTimesDetail[index].isBatch) {
          for (var i = 0, len = this.inputForm.storeTimesDetail.length; i < len; i++) {
            if (this.inputForm.storeTimesDetail[i].isBatch) {
              this.inputForm.storeTimesDetail[i].startTm = null
              this.inputForm.storeTimesDetail[i].endTm = null
              this.inputForm.storeTimesDetail[i].dayYn = this.inputForm.storeTimesDetail[index].dayYn
            }
          }
        } else {
          this.inputForm.storeTimesDetail[index].startTm = null
          this.inputForm.storeTimesDetail[index].endTm = null
        }
      } else {
        if (this.inputForm.storeTimesSimple[index].isBatch) {
          for (var i = 0, len = this.inputForm.storeTimesSimple.length; i < len; i++) {
            if (this.inputForm.storeTimesSimple[i].isBatch) {
              this.inputForm.storeTimesSimple[i].startTm = null
              this.inputForm.storeTimesSimple[i].endTm = null
              this.inputForm.storeTimesSimple[i].dayYn = this.inputForm.storeTimesSimple[index].dayYn
            }
          }
        } else {
          this.inputForm.storeTimesSimple[index].startTm = null
          this.inputForm.storeTimesSimple[index].endTm = null
        }
      }
    },
    batchChange: function (index, column) {
      if (this.inputForm.detailYn) {
        if (
          'breakStartTm1' == column &&
          util.isEmpty(this.inputForm.storeTimesDetail[index].breakEndTm1) &&
          !util.isEmpty(this.inputForm.storeTimesDetail[index].breakStartTm1)
        ) {
          this.inputForm.storeTimesDetail[index].breakEndTm1 = this.inputForm.storeTimesDetail[index].breakStartTm1
        }

        if (
          'breakEndTm1' == column &&
          util.isEmpty(this.inputForm.storeTimesDetail[index].breakStartTm1) &&
          !util.isEmpty(this.inputForm.storeTimesDetail[index].breakEndTm1)
        ) {
          this.inputForm.storeTimesDetail[index].breakStartTm1 = this.inputForm.storeTimesDetail[index].breakEndTm1
        }

        if (
          'breakStartTm2' == column &&
          util.isEmpty(this.inputForm.storeTimesDetail[index].breakEndTm2) &&
          !util.isEmpty(this.inputForm.storeTimesDetail[index].breakStartTm2)
        ) {
          this.inputForm.storeTimesDetail[index].breakEndTm2 = this.inputForm.storeTimesDetail[index].breakStartTm2
        }

        if (
          'breakEndTm2' == column &&
          util.isEmpty(this.inputForm.storeTimesDetail[index].breakStartTm2) &&
          !util.isEmpty(this.inputForm.storeTimesDetail[index].breakEndTm2)
        ) {
          this.inputForm.storeTimesDetail[index].breakStartTm2 = this.inputForm.storeTimesDetail[index].breakEndTm2
        }

        if (this.inputForm.storeTimesDetail[index].isBatch) {
          for (var i = 0, len = this.inputForm.storeTimesDetail.length; i < len; i++) {
            if (this.inputForm.storeTimesDetail[i].isBatch) {
              if (!util.isEmpty(this.inputForm.storeTimesDetail[index][column])) {
                this.inputForm.storeTimesDetail[i][column] = this.inputForm.storeTimesDetail[index][column] + ''
              } else {
                this.inputForm.storeTimesDetail[i][column] = ''
              }

              if (
                'breakStartTm1' == column &&
                util.isEmpty(this.inputForm.storeTimesDetail[i].breakEndTm1) &&
                !util.isEmpty(this.inputForm.storeTimesDetail[i].breakStartTm1)
              ) {
                this.inputForm.storeTimesDetail[i].breakEndTm1 = this.inputForm.storeTimesDetail[i].breakStartTm1
              }

              if (
                'breakEndTm1' == column &&
                util.isEmpty(this.inputForm.storeTimesDetail[i].breakStartTm1) &&
                !util.isEmpty(this.inputForm.storeTimesDetail[i].breakEndTm1)
              ) {
                this.inputForm.storeTimesDetail[i].breakStartTm1 = this.inputForm.storeTimesDetail[i].breakEndTm1
              }

              if (
                'breakStartTm2' == column &&
                util.isEmpty(this.inputForm.storeTimesDetail[i].breakEndTm2) &&
                !util.isEmpty(this.inputForm.storeTimesDetail[i].breakStartTm2)
              ) {
                this.inputForm.storeTimesDetail[i].breakEndTm2 = this.inputForm.storeTimesDetail[i].breakStartTm2
              }

              if (
                'breakEndTm2' == column &&
                util.isEmpty(this.inputForm.storeTimesDetail[i].breakStartTm2) &&
                !util.isEmpty(this.inputForm.storeTimesDetail[i].breakEndTm2)
              ) {
                this.inputForm.storeTimesDetail[i].breakStartTm2 = this.inputForm.storeTimesDetail[i].breakEndTm2
              }
            }
          }
        }
      } else {
        if (
          'breakStartTm1' == column &&
          util.isEmpty(this.inputForm.storeTimesSimple[index].breakEndTm1) &&
          !util.isEmpty(this.inputForm.storeTimesSimple[index].breakStartTm1)
        ) {
          this.inputForm.storeTimesSimple[index].breakEndTm1 = this.inputForm.storeTimesSimple[index].breakStartTm1
        }

        if (
          'breakEndTm1' == column &&
          util.isEmpty(this.inputForm.storeTimesSimple[index].breakStartTm1) &&
          !util.isEmpty(this.inputForm.storeTimesSimple[index].breakEndTm1)
        ) {
          this.inputForm.storeTimesSimple[index].breakStartTm1 = this.inputForm.storeTimesSimple[index].breakEndTm1
        }

        if (
          'breakStartTm2' == column &&
          util.isEmpty(this.inputForm.storeTimesSimple[index].breakEndTm2) &&
          !util.isEmpty(this.inputForm.storeTimesSimple[index].breakStartTm2)
        ) {
          this.inputForm.storeTimesSimple[index].breakEndTm2 = this.inputForm.storeTimesSimple[index].breakStartTm2
        }

        if (
          'breakEndTm2' == column &&
          util.isEmpty(this.inputForm.storeTimesSimple[index].breakStartTm2) &&
          !util.isEmpty(this.inputForm.storeTimesSimple[index].breakEndTm2)
        ) {
          this.inputForm.storeTimesSimple[index].breakStartTm2 = this.inputForm.storeTimesSimple[index].breakEndTm2
        }

        if (this.inputForm.storeTimesSimple[index].isBatch) {
          for (var i = 0, len = this.inputForm.storeTimesSimple.length; i < len; i++) {
            if (this.inputForm.storeTimesSimple[i].isBatch) {
              if (!util.isEmpty(this.inputForm.storeTimesSimple[index][column])) {
                this.inputForm.storeTimesSimple[i][column] = this.inputForm.storeTimesSimple[index][column] + ''
              } else {
                this.inputForm.storeTimesSimple[i][column] = ''
              }

              if (
                'breakStartTm1' == column &&
                util.isEmpty(this.inputForm.storeTimesSimple[i].breakEndTm1) &&
                !util.isEmpty(this.inputForm.storeTimesSimple[i].breakStartTm1)
              ) {
                this.inputForm.storeTimesSimple[i].breakEndTm1 = this.inputForm.storeTimesSimple[i].breakStartTm1
              }

              if (
                'breakEndTm1' == column &&
                util.isEmpty(this.inputForm.storeTimesSimple[i].breakStartTm1) &&
                !util.isEmpty(this.inputForm.storeTimesSimple[i].breakEndTm1)
              ) {
                this.inputForm.storeTimesSimple[i].breakStartTm1 = this.inputForm.storeTimesSimple[i].breakEndTm1
              }

              if (
                'breakStartTm2' == column &&
                util.isEmpty(this.inputForm.storeTimesSimple[i].breakEndTm2) &&
                !util.isEmpty(this.inputForm.storeTimesSimple[i].breakStartTm2)
              ) {
                this.inputForm.storeTimesSimple[i].breakEndTm2 = this.inputForm.storeTimesSimple[i].breakStartTm2
              }

              if (
                'breakEndTm2' == column &&
                util.isEmpty(this.inputForm.storeTimesSimple[i].breakStartTm2) &&
                !util.isEmpty(this.inputForm.storeTimesSimple[i].breakEndTm2)
              ) {
                this.inputForm.storeTimesSimple[i].breakStartTm2 = this.inputForm.storeTimesSimple[i].breakEndTm2
              }
            }
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.form__field-align {
  margin-bottom: 5px;

  text-align: center;
}
.form__field-label {
  margin-top: 10px;
  margin-bottom: 5px;

  font-size: 12px;
}

@media (max-width: 1280px) {
  .form__field-align {
    text-align: left;
  }
  .form__field {
    margin-bottom: 50px;
  }
}
</style>
